import { reactive } from 'vue'
import { Mutation, MutationMitRueckgabe } from './useOfflineQueue'

export const Rezepte = reactive([])
let RezepteGeladen = false

export async function RezepteLaden(Erzwingen = false) {
  if (RezepteGeladen && !Erzwingen) return Rezepte
  const Antwort = await fetch('/backend/rezepteLaden.php', { credentials: 'include' })
  if (!Antwort.ok) return Rezepte
  const Daten = await Antwort.json()
  Rezepte.splice(0, Rezepte.length, ...Daten)
  RezepteGeladen = true
  return Rezepte
}

export function RezeptFinden(Id) {
  return Rezepte.find(r => r.Id === Id)
}

export async function RezeptHinzufuegen(Rezept) {
  const Daten = await MutationMitRueckgabe('/backend/rezeptHinzufuegen.php', Rezept)
  Rezepte.push(Daten)
  return Daten
}

export async function RezeptAktualisieren(Id, Aenderungen) {
  const Rezept = RezeptFinden(Id)
  const Sicherung = Rezept ? { ...Rezept, Zutaten: [...(Rezept.Zutaten || [])] } : null
  await Mutation(
    '/backend/rezeptAktualisieren.php',
    { Id, ...Aenderungen },
    () => { if (Rezept) Object.assign(Rezept, Aenderungen) },
    () => { if (Rezept && Sicherung) Object.assign(Rezept, Sicherung) }
  )
}

// BildDataUrl: JPEG-Data-URL zum Speichern, null zum Entfernen
export async function RezeptBildSpeichern(Id, BildDataUrl) {
  const Daten = await MutationMitRueckgabe('/backend/bildSpeichern.php', {
    Typ: 'Rezept',
    Id,
    ...(BildDataUrl === null ? { Entfernen: true } : { BildBase64: BildDataUrl })
  })
  const Rezept = RezeptFinden(Id)
  if (Rezept) {
    Rezept.HatBild = Daten.HatBild ? 1 : 0
    Rezept.BildVersion = Daten.BildVersion || null
  }
  return Daten
}

export async function RezeptLoeschen(Id) {
  const Index = Rezepte.findIndex(r => r.Id === Id)
  const Sicherung = Index !== -1 ? { ...Rezepte[Index], Zutaten: [...(Rezepte[Index]?.Zutaten || [])] } : null
  await Mutation(
    '/backend/rezeptLoeschen.php',
    { Id },
    () => { if (Index !== -1) Rezepte.splice(Index, 1) },
    () => { if (Sicherung !== null) Rezepte.splice(Index, 0, Sicherung) }
  )
}
